const excludeRegexList = [/unsubscribealert\.aspx/i];

function shouldUseClickHandlerOnSharePointLink(url: string) {
    for (let i = 0; i < excludeRegexList.length; i++) {
        const regex = excludeRegexList[i];
        if (regex.test(url)) {
            return false;
        }
    }

    return true;
}

export default shouldUseClickHandlerOnSharePointLink;
